// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__LMgbC","title":"Info_title__3M_0-","selects":"Info_selects__2Au0X","requiredAsterisk":"Info_requiredAsterisk__2Krkg"};